import { styled } from '../../../theme';
import { Paragraph } from '../../Paragraph';

export const Description = styled(Paragraph)`
	text-align: center;
`;
